<div class="modal-dialog modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">
				<strong>Szűrés</strong>
			</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-3">
			<%- include('/ui/form', {
				params: [ 'search_modal', Anvil.page.search ],
				fields: [
					{
						type: 'text',
						name: 'expression',
						title: 'Szöveges keresés',
						attributes: {
							placeholder: 'Keresés...'
						},
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'operator_service_id',
						title: 'Kezelő szerviz',
						params: {
							maxItems: 1,
							options: [ { id: -1, name: '[ nem hozzárendelt ]' }, ...companies.data.filter(x => x.service_partner == 1) ],
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'name' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}</div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
							},
							placeholder: '[ minden szerviz ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.operator_service_id = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'partner_service_id',
						title: 'Karbantartó szerviz',
						params: {
							maxItems: 1,
							options: [ { id: -1, name: '[ nem hozzárendelt ]' }, ...companies.data.filter(x => x.service_partner == 1) ],
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'name' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}</div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
							},
							placeholder: '[ minden szerviz ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.partner_service_id = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'inspection_due',
						title: 'Felülvizsgálat esedékessége',
						params: {
							maxItems: 1,
							options: [
								{ id: 'unknown', name: '[ ismeretlen ]' },
								{ id: 'overdue', name: 'lejárt' },
								{ id: '7_days', name: '1 héten belül' },
								{ id: '1_month', name: '1 hónapon belül' },
								{ id: '3_months', name: '3 hónapon belül' }
							],
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'name' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}</div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
							},
							placeholder: '[ bármely időszak ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.inspection_due = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'text',
						name: 'ap_list',
						title: 'AP szám lista',
						attributes: {
							placeholder: 'Több AP számra keresés egyszerre'
						},
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
				]
			}) %>
		</div>
	</div>
</div>
